document.addEventListener('DOMContentLoaded', () => {
  const ElementIds = {
    AboutHero: 'about',
    CateringHero: 'catering',
    CookiesHero: 'cookies',
    WholesaleHero: 'wholesale',
  };

  const syncHeroHeight = (headerHeight) => {
    aboutHero.style.minHeight = `calc(100vh - ${headerHeight}px)`;

    cateringHero.style.height = `calc(100vh - ${headerHeight}px)`;
    // cookiesHero.style.minHeight = `calc(100vh - ${headerHeight}px)`;
    wholesaleHero.style.height = `calc(100vh - ${headerHeight}px)`;
  };

  /**
   * @type {HTMLElement}
   */
  const aboutHero = document.getElementById(ElementIds.AboutHero);
  const cateringHero = document.getElementById(ElementIds.CateringHero);
  const cookiesHero = document.getElementById(ElementIds.CookiesHero);
  const wholesaleHero = document.getElementById(ElementIds.WholesaleHero);
  const header = document.getElementsByTagName('header')?.[0];

  if (header) {
    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0];
      syncHeroHeight(entry.target.clientHeight);
    });
    syncHeroHeight(header.clientHeight);
    resizeObserver.observe(header);
  }
});
